import React, { useEffect } from "react";
import SelectDropDown from "../SelectDropDown";
import { useDispatch, useSelector } from "react-redux";
import { InvestorAddFormData } from "../../actions/adminAction";
import DatePickerInput from "../DatePickerInput";
import { convertDateToDDMMMYYYY } from "../../utils/DateFormate";
import { pincode } from "../../actions/usersActions";
import "../../styles/profile.css";

export default function StaticNomineeForm({
  formik,
  nomineeCount,
  setNomineeCount,
  noNominee,
  setNoNominee,
  soaNominee,
  setSoaNominee,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(InvestorAddFormData());
  }, [dispatch]);
  console.log("nomineeCount", nomineeCount);

  const userOnboardGetData =
    useSelector((state) => state.admin.adminAddInvestorData) || {};

  const addNominee = () => {
    if (nomineeCount < 3) {
      setNomineeCount(nomineeCount + 1);
      setNoNominee("N");
    }
  };

  const deleteNominee = () => {
    if (nomineeCount > 1) {
      setNomineeCount(nomineeCount - 1);
    }
  };

  const nomineeTypeOptions = [
    { value: "1", label: "PAN" },
    { value: "2", label: "Aadhar" },
    { value: "3", label: "Driving Licence" },
    { value: "4", label: "Passport" },
  ];

  const callStateAndDistrict = async (pin, cityKey, stateKey, countryKey) => {
    try {
      if (pin?.length === 6) {
        const payload = { pincode: pin };
        dispatch(pincode(payload))
          .then((res) => {
            formik?.setFieldValue(
              cityKey,
              res?.data?.data?.city ? res?.data?.data?.city : ""
            );
            formik?.setFieldValue(
              stateKey,
              res?.data?.data?.state_code ? res?.data?.data?.state_code : ""
            );
            formik?.setFieldValue(
              countryKey,
              res?.data?.data?.country_code || ""
            );
          })
          .catch((error) => {
            console.log("Error fetching city/state:", error);
          });
      }
    } catch (error) {
      console.error("Error in pincode lookup:", error);
    }
  };

  const parseDate = (input) => {
    if (!input) return null;

    // Check if input is ISO format
    if (input?.includes("T")) {
      const date = new Date(input);
      return isNaN(date.getTime()) ? null : date;
    }

    // Assume format is DD-MM-YYYY
    const [day, month, year] = input?.split("-").map(Number);
    if (!day || !month || !year) return null;

    return new Date(year, month - 1, day); // month is 0-indexed
  };

  const calculateAge = (dob) => {
    const birthDate = parseDate(dob);
    if (!birthDate) return null;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const guardianOptions = Object.entries(
    userOnboardGetData?.data?.guardian_relations || {}
  ).map(([value, label]) => ({
    value,
    label,
  }));

  return (
    <div className="row form_body justify-content-center">
      <div className="col-xl-7 col-lg-10 col-md-10 my-2">
        <div className="form-check mb-4">
          <input
            className="form-check-input"
            type="checkbox"
            id="no_nominee"
            checked={noNominee == "Y"}
            onChange={(e) => {
              if (e.target.checked == true) {
                setNomineeCount(0);
                setNoNominee("Y");
              } else {
                setNomineeCount(1);
                setNoNominee("N");
              }
            }}
          />
          <label className="form-check-label" for="no_nominee">
            Customer does not wish to add nominee.
          </label>
        </div>
        <div className="form-check mb-4">
          <input
            className="form-check-input"
            type="checkbox"
            id="nominee_soa"
            checked={soaNominee == "Y"}
            onChange={(e) => {
              setSoaNominee(e.target.checked ? "Y" : "N");
              formik.setFieldValue("nominee_soa", e.target.checked ? "Y" : "N");
            }}
          />
          <label className="form-check-label" for="no_nominee">
            SOA
          </label>
          <div className="tooltip-wrapper">
            <span className="fa fa-info-circle info-icon"></span>
            <div className="tooltip-content">
              If the SOA is checked, only the nominee registration status will
              be shown in the SOA.
              <br />
              If unchecked, the names of the registered nominee will be
              displayed.
            </div>
          </div>
        </div>
        <form id="manage_nominee">
          {[...Array(nomineeCount)].map((_, index) => {
            const i = index + 1;
            const nameKey = `nominee_${i}_name`;
            const relationKey = `nominee_${i}_relationship`;
            const dobKey = `nominee_${i}_dob`;
            const percentKey = `nominee_${i}_applicable`;
            const panKey = `nominee_${i}_pan`;
            const guardianNameKey = `nominee_${i}_guardian`;
            const guardianPanKey = `nominee_${i}_guardian_pan`;
            // const guardianRelationKey = `nominee_${i}_guardian_relation`;

            // Conditionally use different key prefixes for nominee 1 vs nominee 2/3
            const prefix = i === 1 ? `nominee_${i}` : `nominee_${i}`;
            const pincodeKey = `${prefix}_pin`;
            const cityKey = `${prefix}_city`;
            const stateKey = `${prefix}_state`;

            const idTypeKey = `nominee_${i}_identity_type`;
            const idNumberKey = `nominee_${i}_identity_no`;
            const emailKey = `nominee_${i}_email`;
            const mobileKey = `nominee_${i}_mobile`;
            const countryKey = `nominee_${i}_country`;

            // Special case for address keys
            const address1Key = `nominee_${i}_address1`;
            const address2Key = `nominee_${i}_address2`;

            const dob = formik.values[dobKey];
            const age = calculateAge(dob);

            return (
              <div key={i}>
                <h5 className="nominee_title">{i} Nominee:</h5>

                {/* Nominee Name */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={nameKey} className="form-label">
                      Nominee Name *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      id={nameKey}
                      name={nameKey}
                      placeholder="Enter Nominee Name"
                      value={formik.values[nameKey] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[nameKey] && formik.errors[nameKey] && (
                      <div className="text-danger">
                        {formik.errors[nameKey]}
                      </div>
                    )}
                  </div>
                </div>

                {/* Relation */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={relationKey} className="form-label">
                      Relation *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <SelectDropDown
                      name={relationKey}
                      id={relationKey}
                      value={formik.values[relationKey] || ""}
                      changeFunction={(value) =>
                        formik.setFieldValue(relationKey, value)
                      }
                      options={
                        userOnboardGetData?.data?.relations?.length > 0
                          ? userOnboardGetData?.data?.relations?.map(
                              (relation) => ({
                                value: relation.relationship_code,
                                label: relation.relationship_name,
                              })
                            )
                          : []
                      }
                    />
                    {formik.touched[relationKey] &&
                      formik.errors[relationKey] && (
                        <div className="text-danger">
                          {formik.errors[relationKey]}
                        </div>
                      )}
                  </div>
                </div>

                {/* Date of Birth */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={dobKey} className="form-label">
                      Date of Birth *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <DatePickerInput
                      selectedDate={parseDate(formik.values[dobKey]) || null}
                      onChange={(date) =>
                        formik.setFieldValue(dobKey, date ? date : "")
                      }
                      minDate={new Date("1900-01-01")}
                      maxDate={new Date()}
                      name={dobKey}
                    />
                    {/* <DatePickerInput
                                                    // id={dobKey}
                                                    selectedDate={formik.values[dobKey] || ""}
                                                    maxDate={new Date().toISOString().split("T")[0]}
                                                    minDate="1900-01-01"
                                                    // onChange={(date) => setFieldValue(dobKey, date)}
                                                    onChange={(date) =>
                        formik.setFieldValue(
                          dobKey,
                          date
                        )
                      }
                                                    name={dobKey}
                                                  /> */}
                    {formik.touched[dobKey] && formik.errors[dobKey] && (
                      <div className="text-danger">{formik.errors[dobKey]}</div>
                    )}
                  </div>
                </div>

                {/* Nominee % */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={percentKey} className="form-label">
                      Nominee % *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="number"
                      className="form-control"
                      id={percentKey}
                      name={percentKey}
                      placeholder="Enter Nominee %"
                      value={formik.values[percentKey] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[percentKey] &&
                      formik.errors[percentKey] && (
                        <div className="text-danger">
                          {formik.errors[percentKey]}
                        </div>
                      )}
                  </div>
                </div>

                {(age >= 18 || age === null) && (
                  <>
                    {/* Nominee Type */}
                    <div className="row mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor={idTypeKey} className="form-label">
                          Nominee Identity Type *
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <SelectDropDown
                          name={idTypeKey}
                          id={idTypeKey}
                          value={formik.values[idTypeKey] || "1"}
                          changeFunction={(value) =>
                            formik.setFieldValue(idTypeKey, value)
                          }
                          options={nomineeTypeOptions?.map((state) => ({
                            value: state.value,
                            label: state.label,
                          }))}
                          disabled="true"
                        />
                        {/* <input
                          type="text"
                          name={idTypeKey}
                          id={idTypeKey}
                          className="form-control"
                          value={
                            nomineeTypeOptions.find((opt) => opt.value === "1")
                              ?.label || ""
                          }
                          disabled
                        />
                        <input type="hidden" name={idTypeKey} value="1" /> */}
                        {formik.touched[idTypeKey] &&
                          formik.errors[idTypeKey] && (
                            <div className="text-danger">
                              {formik.errors[idTypeKey]}
                            </div>
                          )}
                      </div>
                    </div>

                    {/* Nominee Id Number */}
                    <div className="row mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label htmlFor={idNumberKey} className="form-label">
                          Nominee ID number *
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          id={idNumberKey}
                          name={idNumberKey}
                          placeholder="Enter Id Number"
                          value={formik.values[idNumberKey] || ""}
                          onChange={(e) => {
                            const upperValue = e.target.value.toUpperCase();
                            formik.setFieldValue(idNumberKey, upperValue);
                          }}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched[idNumberKey] &&
                          formik.errors[idNumberKey] && (
                            <div className="text-danger">
                              {formik.errors[idNumberKey]}
                            </div>
                          )}
                      </div>
                    </div>
                  </>
                )}

                {/* Nominee Email */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={emailKey} className="form-label">
                      Nominee Email *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      id={emailKey}
                      name={emailKey}
                      placeholder="Enter Nominee Email"
                      value={formik.values[emailKey] || ""}
                      // onChange={formik.handleChange}
                      onChange={(e) =>
                        formik.setFieldValue(
                          emailKey,
                          e.target.value.toLowerCase()
                        )
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[emailKey] && formik.errors[emailKey] && (
                      <div className="text-danger">
                        {formik.errors[emailKey]}
                      </div>
                    )}
                  </div>
                </div>

                {/* Nominee Mobile Number */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={mobileKey} className="form-label">
                      Nominee Mobile *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="number"
                      className="form-control"
                      id={mobileKey}
                      name={mobileKey}
                      placeholder="Enter Nominee Mobile"
                      value={formik.values[mobileKey] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[mobileKey] && formik.errors[mobileKey] && (
                      <div className="text-danger">
                        {formik.errors[mobileKey]}
                      </div>
                    )}
                  </div>
                </div>

                {/* Nominee Address */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={address1Key} className="form-label">
                      Nominee Address 1 *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      id={address1Key}
                      name={address1Key}
                      placeholder="Enter Nominee Address 1"
                      value={formik.values[address1Key] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[address1Key] &&
                      formik.errors[address1Key] && (
                        <div className="text-danger">
                          {formik.errors[address1Key]}
                        </div>
                      )}
                  </div>
                </div>

                {/* Nominee Address 2 */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={address2Key} className="form-label">
                      Nominee Address 2 *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      id={address2Key}
                      name={address2Key}
                      placeholder="Enter Nominee Address 2"
                      value={formik.values[address2Key] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[address2Key] &&
                      formik.errors[address2Key] && (
                        <div className="text-danger">
                          {formik.errors[address2Key]}
                        </div>
                      )}
                  </div>
                </div>

                {/* Nominee Pin Code */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={pincodeKey} className="form-label">
                      Nominee Pincode *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="number"
                      className="form-control"
                      id={pincodeKey}
                      name={pincodeKey}
                      placeholder="Enter Nominee Pincode"
                      value={formik.values[pincodeKey] || ""}
                      onChange={(e) => {
                        formik.handleChange(e);
                        callStateAndDistrict(
                          e.target.value,
                          cityKey,
                          stateKey,
                          countryKey
                        );
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[pincodeKey] &&
                      formik.errors[pincodeKey] && (
                        <div className="text-danger">
                          {formik.errors[pincodeKey]}
                        </div>
                      )}
                  </div>
                </div>

                {/* Nominee City */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={cityKey} className="form-label">
                      Nominee City *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      id={cityKey}
                      name={cityKey}
                      placeholder="Enter Nominee City"
                      value={formik.values[cityKey] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[cityKey] && formik.errors[cityKey] && (
                      <div className="text-danger">
                        {formik.errors[cityKey]}
                      </div>
                    )}
                  </div>
                </div>

                {/* Nominee State */}
                {/* <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={stateKey} className="form-label">
                      Nominee State *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <SelectDropDown
                      name={stateKey}
                      id={stateKey}
                      value={formik.values[stateKey] || ""}
                      changeFunction={(value) =>
                        formik.setFieldValue(stateKey, value)
                      }
                      options={userOnboardGetData?.data?.states?.map(
                        (state) => ({
                          value: state.state_code,
                          label: state.state_name,
                        })
                      )}
                    />
                    {formik.touched[stateKey] && formik.errors[stateKey] && (
                      <div className="text-danger">
                        {formik.errors[stateKey]}
                      </div>
                    )}
                  </div>
                </div> */}

                {/* Nominee Country */}
                <div className="row mb-4">
                  <div className="col-lg-5 col-md-6">
                    <label htmlFor={countryKey} className="form-label">
                      Nominee Country *
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      id={countryKey}
                      name={countryKey}
                      placeholder="Enter Nominee Country"
                      value={formik.values[countryKey] || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      // disabled
                    />
                    {formik.touched[countryKey] &&
                      formik.errors[countryKey] && (
                        <div className="text-danger">
                          {formik.errors[countryKey]}
                        </div>
                      )}
                  </div>
                </div>
                {/* PAN or Guardian Details */}
                {age >= 18 || age === null ? (
                  <></>
                ) : (
                  // <div className="row mb-4">
                  //   <div className="col-lg-5 col-md-6">
                  //     <label htmlFor={panKey} className="form-label">
                  //       Enter PAN Number *
                  //     </label>
                  //   </div>
                  //   <div className="col-lg-7 col-md-6">
                  //     <input
                  //       type="text"
                  //       className="form-control"
                  //       id={panKey}
                  //       name={panKey}
                  //       placeholder="Enter PAN Number"
                  //       value={formik.values[panKey] || ""}
                  //       onChange={formik.handleChange}
                  //       onBlur={formik.handleBlur}
                  //     />
                  //     {formik.touched[panKey] && formik.errors[panKey] && (
                  //       <div className="text-danger">
                  //         {formik.errors[panKey]}
                  //       </div>
                  //     )}
                  //   </div>
                  // </div>
                  <>
                    {" "}
                    <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor={`percent-${index}`}
                          className="form-label"
                        >
                          Guardian Name*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          id={guardianNameKey}
                          name={guardianNameKey}
                          className="form-control"
                          placeholder="Guardian Name"
                          value={formik?.values[guardianNameKey]}
                          onChange={formik?.handleChange}
                        />
                        {formik.touched[guardianNameKey] &&
                          formik.errors[guardianNameKey] && (
                            <div className="text-danger">
                              {formik.errors[guardianNameKey]}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor={`percent-${index}`}
                          className="form-label"
                        >
                          Guardian Pan*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <input
                          type="text"
                          id={guardianPanKey}
                          name={guardianPanKey}
                          className="form-control"
                          placeholder="Guardian Pan"
                          value={formik?.values[guardianPanKey]}
                          onChange={(e) => {
                            formik.setFieldValue(
                              guardianPanKey,
                              e.target.value.toUpperCase()
                            );
                          }}
                        />
                        {formik.touched[guardianPanKey] &&
                          formik.errors[guardianPanKey] && (
                            <div className="text-danger">
                              {formik.errors[guardianPanKey]}
                            </div>
                          )}
                        {/* {errors[guardianPanKey] && (
                          <div className="text-danger">
                            {errors[guardianPanKey]}
                          </div>
                        )} */}
                      </div>
                    </div>
                    {/* <div className="row align-items-center mb-4">
                      <div className="col-lg-5 col-md-6">
                        <label
                          htmlFor={guardianRelationKey}
                          className="form-label"
                        >
                          Guardian Relation*
                        </label>
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <SelectDropDown
                          name={guardianRelationKey}
                          id={guardianRelationKey}
                          value={formik?.values[guardianRelationKey]}
                          changeFunction={(value) =>
                            formik?.setFieldValue(guardianRelationKey, value)
                          }
                          options={guardianOptions}
                        />
                        {formik.touched[guardianRelationKey] &&
                          formik.errors[guardianRelationKey] && (
                            <div className="text-danger">
                              {formik.errors[guardianRelationKey]}
                            </div>
                          )}
                      </div>
                    </div> */}
                  </>
                  // <>
                  //   <div className="row mb-4">
                  //     <div className="col-lg-5 col-md-6">
                  //       <label htmlFor={guardianNameKey} className="form-label">
                  //         Guardian Name *
                  //       </label>
                  //     </div>
                  //     <div className="col-lg-7 col-md-6">
                  //       <input
                  //         type="text"
                  //         className="form-control"
                  //         id={guardianNameKey}
                  //         name={guardianNameKey}
                  //         placeholder="Guardian Name"
                  //         value={formik.values[guardianNameKey] || ""}
                  //         onChange={formik.handleChange}
                  //         onBlur={formik.handleBlur}
                  //       />
                  //       {formik.touched[guardianNameKey] &&
                  //         formik.errors[guardianNameKey] && (
                  //           <div className="text-danger">
                  //             {formik.errors[guardianNameKey]}
                  //           </div>
                  //         )}
                  //     </div>
                  //   </div>
                  // </>
                )}

                {/* Delete Button */}
                {nomineeCount > 1 && (
                  <button
                    type="button"
                    className="delete_button text-decoration-none"
                    onClick={deleteNominee}
                  >
                    <span>-</span> Delete nominee
                  </button>
                )}
              </div>
            );
          })}
          {noNominee !== "Y" && nomineeCount < 3 && (
            <button
              type="button"
              className="more_button text-decoration-none"
              onClick={addNominee}
            >
              <span>+</span> Add More
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
